<template>
    <div id="main">
        <el-menu
            mode="horizontal"
            class="topmenu"
            :default-active="activeIndex"
            @select="handleselect"
        >
            <el-menu-item index="1">收藏文章</el-menu-item>
            <el-menu-item index="2">收藏视频</el-menu-item>
        </el-menu>
        <div class="sort">
            <p>共收藏{{total}}篇文章</p>
            <!-- <div class="flex-x">
        <p class="sortright">默认</p>
        <i class="el-icon-arrow-down"></i>
        <div class="line"></div>
        <i class="el-icon-sort"></i>
            </div>-->
        </div>
        <div class="essaycontent">
            <div v-for="single in essaylist" :key="single.id" v-show="essaylist.length > 0">
                <single-article :single="single" type="collection"></single-article>
            </div>
            <el-pagination
                background
                layout="jumper, prev, pager, next, slot, total"
                :total="total"
                :current-page="page"
                @current-change="currentChange"
                @prev-click="prevClick"
                @next-click="nextClick"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    import SingleArticle from '../common/SingleArticle';
    export default {
        components: {
            SingleArticle
        },
        data() {
            return {
                activeIndex: '1',
                essaytitle: '',
                essaylist: [],
                total: 0,
                page: 1
            };
        },
        mounted() {
            this.getessaylist();
        },
        methods: {
            handleselect(val) {
                this.activeIndex = val;
                this.essaylist = [];
                if (val == 1) {
                    this.getessaylist();
                } else {
                    this.getradiolist();
                }
            },
            getessaylist() {
                this.httpGet(this.$root.getCollection, {
                    category: 1,
                    type: 1,
                    page: this.page,
                    size: 10
                })
                    .then(result => {
                        if (result.count) {
                            this.essaylist.push(...result.data);
                            // 为了适应组件将aid改为id
                            this.essaylist.forEach(item => {
                                delete item.id;
                                item.id = item.aid;
                            });
                            this.total = Number(result.count);
                        } else {
                            this.essaylist = [];
                            this.total = 0;
                        }
                        console.log(result.data, 88);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getradiolist() {
                this.httpGet(this.$root.getCollection, {
                    category: 1,
                    type: 2,
                    page: this.page,
                    size: 10
                })
                    .then(result => {
                        if (result.count) {
                            this.essaylist.push(...result.data);
                            this.total = Number(result.count);
                        } else {
                            this.essaylist = [];
                            this.total = 0;
                        }
                        console.log(result, 98);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            gotoquery(e) {
                this.$router.push({
                    name: 'article-details',
                    query: {
                        id: e
                    }
                });
            },
            currentChange(page) {
                console.log('currentChange', page);
                this.page = page;
                this.essaylist = [];
                if (this.activeIndex == 1) {
                    this.getessaylist();
                } else {
                    this.getradiolist();
                }
            },
            prevClick(page) {
                console.log('currentChange1', page);
                this.page = page;
                this.essaylist = [];
                if (this.activeIndex == 1) {
                    this.getessaylist();
                } else {
                    this.getradiolist();
                }
            },
            nextClick(page) {
                console.log('currentChange2', page);
                this.page = page;
                this.essaylist = [];
                if (this.activeIndex == 1) {
                    this.getessaylist();
                } else {
                    this.getradiolist();
                }
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    * {
        box-sizing: border-box;
    }

    .flex-x {
        flex-x();
    }

    .single-article {
        // border-radius: 8px;
        // overflow: hidden;
        // margin-bottom: 20px;
        // width: 100% !important;
        // max-width: 880px !important;
    }

    .topmenu {
        width: 100%;
        height: 64px;
        border-radius: 8px;
        padding-right: 0px !important;
    }

    .sort {
        margin-top: 24px;
        width: 100%;
        flex-x();
        font-size: 14px;
        opacity: 0.65;

        p {
            flex-shrink: 0;
        }

        .sortright {
        }

        .el-icon-arrow-down {
            margin-right: 26px;
            margin-left: 4px;
        }
    }

    .essaycontent {
        margin-top: 24px;
        width: 100%;
        // max-width: 832px
        // padding 0 24px
        background white

    }

    >>>.el-pagination {
        // width: 840px;
        flex-center();
        padding: 20px;
        background: white;
    }
</style>
